import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorRetryProps {
  message?: string;
  onRetry?: () => void;
  compact?: boolean;
}

export default function ErrorRetry({ message = "Something went wrong", onRetry, compact = false }: ErrorRetryProps) {
  if (compact) {
    return (
      <div className="flex items-center justify-center gap-2 py-3 text-sm text-muted-foreground">
        <AlertTriangle className="w-4 h-4 text-primary" />
        <span>{message}</span>
        {onRetry && (
          <button onClick={onRetry} className="text-primary hover:underline font-medium ml-1">
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
        <AlertTriangle className="w-6 h-6 text-primary" />
      </div>
      <div>
        <p className="text-sm font-medium text-foreground">{message}</p>
        <p className="text-xs text-muted-foreground mt-1">Please check your connection and try again</p>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="gap-2 mt-1">
          <RefreshCw className="w-3.5 h-3.5" />
          Try Again
        </Button>
      )}
    </div>
  );
}
